'use strict';

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _getColumnWidth = function _getColumnWidth(columnCount, rowWidth, size) {
  var fixed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return fixed ? String(size / columnCount * rowWidth) + 'px' : size / columnCount * 100 + '%';
};

exports.getColumnWidth = _getColumnWidth;

var gutterCalc = exports.gutterCalc = function gutterCalc(gutter) {
  // Assume pixel value when type is number
  if (typeof gutter === 'number') {
    return gutter / 2 + 'px';
  }

  var gutterVal = parseFloat(gutter, 10);
  var gutterUnit = gutter.split(gutterVal)[1]; // Return with original unit

  if (gutterUnit) {
    return '' + gutterVal / 2 + gutterUnit;
  } // If string but missing unit


  return gutterVal / 3 + 'px';
};

var defaultConfig = {
  columnCount: 12,
  rowWidth: 1200,
  gutter: '1rem',
  breakpoints: {
    xxs: 0
  }
};

exports.default = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mergedConfig = _extends({}, defaultConfig, config);

  var columnCount = mergedConfig.columnCount,
      rowWidth = mergedConfig.rowWidth,
      gutter = mergedConfig.gutter,
      breakpoints = mergedConfig.breakpoints;
  return {
    rowWidth: rowWidth,
    columnCount: columnCount,
    breakpoints: breakpoints,
    gutter: gutter,
    getColumnWidth: function getColumnWidth(args, fixed) {
      return _getColumnWidth(columnCount, rowWidth, args, fixed);
    },
    getGutterWidth: function getGutterWidth(args) {
      return gutterCalc(args);
    }
  };
};